define([
    'componentsCore',
    'mediaControls/mediaOverlayControls/mediaOverlayControls',
    'mediaControls/mediaControlsContainer/mediaControlsContainer',
    'mediaControls/mediaControlPlay/mediaControlPlay',
    'mediaControls/mediaControlFullscreen/mediaControlFullscreen',
    'mediaControls/mediaControlVolume/mediaControlVolume',
    'mediaControls/mediaControlProgress/mediaControlProgress',
    'mediaControls/mediaControlTime/mediaControlTime',
    'mediaControls/mediaControlStoryboard/mediaControlStoryboard',
    'skins',
    'mediaControls/skins/skins.json',
    // Load Data requirements checkers
    'mediaControls/utils/mediaControlsDataRequiermentsChecker'
], function (
    componentsCore,
    mediaOverlayControls,
    mediaControlsContainer,
    mediaControlPlay,
    mediaControlFullscreen,
    mediaControlVolume,
    mediaControlProgress,
    mediaControlTime,
    mediaControlStoryboard,
    skinsPackage,
    skinsJson
) {
    'use strict';

    const mediaControls = {
        mediaOverlayControls,
        mediaControls: mediaControlsContainer,
        mediaControlPlay,
        mediaControlFullscreen,
        mediaControlVolume,
        mediaControlProgress,
        mediaControlTime,
        mediaControlStoryboard
    };

    componentsCore.compRegistrar.register('wysiwyg.viewer.components.MediaOverlayControls', mediaControls.mediaOverlayControls)
        .register('wysiwyg.viewer.components.MediaControls', mediaControls.mediaControls)
        .register('wysiwyg.viewer.components.MediaControlPlay', mediaControls.mediaControlPlay)
        .register('wysiwyg.viewer.components.MediaControlFullscreen', mediaControls.mediaControlFullscreen)
        .register('wysiwyg.viewer.components.MediaControlVolume', mediaControls.mediaControlVolume)
        .register('wysiwyg.viewer.components.MediaControlProgress', mediaControls.mediaControlProgress)
        .register('wysiwyg.viewer.components.MediaControlTime', mediaControls.mediaControlTime)
        .register('wysiwyg.viewer.components.MediaControlStoryboard', mediaControls.mediaControlStoryboard);

    skinsPackage.skinsMap.addBatch(skinsJson);

    return mediaControls;
});
